const AceHwyInbondArrivalKeys = {
  TITLE: "title",
  TRIP_NO: "tripNo",
  ETA_FIRST_PORT_US: "etaFirstPortUS",
  FIRST_PORT: "firstPort",
  INBOND7512_NO: "inbond7512No",
  INBOND_DATE: "inbondDate",
  INBOND_DESTINATION: "inbondDestination",
  FIRMS_CODE: "firmsCode",
  MSG_FUNCTION: "msgFunction",
  ACTION_CODE: "actionCode",
  SAVE_BUTTON: "saveButton",
  SEND_BUTTON: "sendButton",
  EDIT_BUTTON: "editButton",
  VIEW_BUTTON: "viewButton",
  CLONE_BUTTON: "cloneButton",
  DELETE_BUTTON: "deleteButton",
  SUBMIT_BUTTON: "submitButton",
  STATUS: "status",
  MESSAGE_CODE: "messageCode",
  ID: "id",
  CREATED_BY: "createdBy",
  CREATED_DATE: "createdDate",
  UPDATED_BY: "updatedBy",
  UPDATED_DATE: "updatedDate",
  SUBMITTED_BY: "submittedBy",
  SUBMITTED_DATE: "submittedDate",
  VERSION: "version",
  PARTY_ID: "partyId",
  CLONE_MULTIPLE_RECORDS:"cloneMultiple",
  RESPONSE_TITLE:"responseTitle",
  ACTIVITYLOG_TITLE: "activityLogs",
  LOGIN_USER_ID:"loginUserID",
  FUNCTION_CODE:"FunctionCode",
  AUDIT_DESC:"AuditDesc",
  RESPONSE_TITLE:"inbondResponse",
  BATCH_ID:"batchID",
  CBSA_PROCESSING_DATE:"cbsaProcDate",
  CBP_REF_NO:"cbpRefNo",
  TRIP_NO:"tripNo",
  RESPONSE_CODE:"responseCode",
  RESPONSE_TEXT:"responseText",
  RESPONSE_DATE:"responseDate",
  SUBMISSION_TYPE: "submissionType",
  ARRIVAL_STATUS: "arrivalStatus",
  EXPORT_STATUS: "exportStatus",
  CREATED_SUCCESS_MESSAGE : "createdSuccess",
  SUBMIT_SUCCESS_MESSAGE:"submitSuccessMsg",
  SUBMIT_FAIL_MESSAGE : "submitFailMessage",
  USE_MANIFEST : "useManifest",
  INBOND_DEPARTURE_DATE : "inbondDepartureDate",
  DELETE_SUCCESS : "deleteSuccessMsg",
  UPLOAD_IB_STAND_ALONE : "uploadIBStandAlone",
  CREATE_IB_FROM_MANIFEST : "createIBFromManifest",
  CREATE_IB_STAND_ALONE :"createIBStandAlone",
  EDIT_SENT_RECORD : "editSentRecords",
  SUBMIT_INVALID_MSG : "submitInvalidMsg",
  DELETE_CONFIRMATION_MSG:"deleteConfirmationMsg",
  DELETE_CONFIRMATION_BUTTON : "deleteConfirmButton",
  DELETE_CANCEL_BUTTON : "deleteCancelButton",
  PAST_15_DAYS : "past15Days",
  PAST_30_DAYS : "past30Days",
  PAST_60_DAYS : "past60Days",
  LAST_MODIFIED_DATE : "lastModifiedDate",
  ERROR_CODE : "errorCode",
  ERROR_DESC : "errorDesc",
  REJECT_TYPE : "rejectType",
  INBOND_ARRIVAL_TAB : "inbondArrivalTab",
  INBOND_RESPONSE_TAB : "inbondResponseTab",
  ACTIVITY_LOG_TAB : "activityLogTab",
  MANIFEST_TITLE: "manifestTitle",
  EXPORT_OF_INBOND: "exportOfInbondNumber",
  ARRIVAL_OF_INBOND: "arrivalOfInbondNumber",
  NOT_RECEIVED : "notReceivedMessage",
  INBOND_APPELIED_SUCCESS_MESSAGE : "inbondAppliedSuccessMsg",
  validation: {
    ALPHA_NUMERIC: 'validation.alphaNumeric',
    TRIP_NO_MAX_LENGTH: 'validation.tripNoMaxLength',
    DATE_FORMAT_ERROR: 'validation.dateFormatError',
    INBOND_NUMBER_MAX_LENGTH: 'validation.inbondNumberMaxLength'
  }
} 

export default AceHwyInbondArrivalKeys
